import { Component, OnInit } from '@angular/core';

/**
 * Componente DashBoard, su objetivo es mostrar la información más relevante para el usuario
 */
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  /**
     * @ignore
     */
  constructor() { }

  /**
     * @ignore
     */
  ngOnInit() {
  }

}
